module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'goodsCategoryList') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.base.title),
      callback: function($$v) {
        _vm.$set(_vm.base, "title", $$v)
      },
      expression: "base.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectCategory
    },
    model: {
      value: (_vm.base.category_id),
      callback: function($$v) {
        _vm.$set(_vm.base, "category_id", $$v)
      },
      expression: "base.category_id"
    }
  }, _vm._l((_vm.categorylist), function(item) {
    return _c('el-option', {
      key: item.category_name,
      attrs: {
        "label": item.category_name,
        "value": item.category_id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.getCategoryLists
    }
  }, [_vm._v("点击获取分类数据")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.base, "subtitle", $$v)
      },
      expression: "base.subtitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), (_vm.config.type === 'goods_category_list') ? _c('el-form-item', {
    attrs: {
      "label": "开启排行榜"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.leaderboard),
      callback: function($$v) {
        _vm.$set(_vm.config, "leaderboard", $$v)
      },
      expression: "config.leaderboard"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示价格"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.showPrice),
      callback: function($$v) {
        _vm.$set(_vm.config, "showPrice", $$v)
      },
      expression: "config.showPrice"
    }
  })], 1), _vm._v(" "), (_vm.config.type === 'goods_category_list') ? _c('el-form-item', {
    attrs: {
      "label": "商品列表"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setting-item item-selected"
    }, [_c('img', {
      staticClass: "thumbnail",
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt"
    })])])
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "iconfont icon-cog banner-button-uploader",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.setGoods
    }
  }, [_vm._v(" 设置商品")])], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77c1f3a7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77c1f3a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/goods_category_list.vue
// module id = 2841
// module chunks = 0